// @ts-ignore
import React, { FC } from 'react';
import styled from '@emotion/styled';
import { Container } from 'reactstrap';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { isIOS } from 'react-device-detect';
import newtheme from '../../newtheme';
import RatingStarsImage from '../../assets/images/RatingStars';
import AppStoreButtonIcon from '../../assets/images/RatingsAppStore';
import PlayStoreButtonIcon from '../../assets/images/RatingsPlayStore';
import config from '../../config';
import { openModal } from '../../actions/modal';
import ModalTypes from '../../types/ModalTypes';

interface IPropsFromDispatch {
    openModal: typeof openModal;
}

const RatingsWrapper = styled.div`
    background: ${newtheme.colors.backgroundNavy};
    padding: 77px 10px;
    width: 100%;

    ${newtheme.cssBreakpoints.tiny} {
        padding-bottom: 30px;
    }
`;

const Wrapper = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;
const RatingItem = styled.div`
    ${newtheme.cssBreakpoints.tiny} {
        display: none;
    }

    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    &:first-child {
        margin-right: 160px;
    }
`;

const RatingItemMobile = styled.div`
    & > a {
        margin-top: 0px;
        margin-right: 20px;
    }

    width: 100%;
    align-items: center;
    justify-content: center;
    display: none;

    ${newtheme.cssBreakpoints.tiny} {
        display: flex;
    }
`;

const RatingHeading = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;
const RatingNumber = styled.h2`
    font-size: 95px;
    font-weight: 600;
    margin-right: 16px;
    margin-bottom: 0px;

    ${newtheme.cssBreakpoints.large} {
        font-size: 70px;
    }
`;
const RatingPlatform = styled.p`
    font-size: 36px;
    font-weight: 600;
    line-height: 120%;

    ${newtheme.cssBreakpoints.large} {
        font-size: 26px;
    }
`;
const RatingPlatformButton = styled.a`
    ${newtheme.cssBreakpoints.tiny} {
        margin-top: 0;
        margin-right: 10px;
    }
    background: none;
    border: none;
    outline: none;
    display: block;
    text-decoration: none;
    margin-top: 36px;
    cursor: pointer;
`;

const RatingStars = styled.div`
    display: block;
`;

const RatingsDate = styled.p`
    font-weight: 600;
    font-size: 14px;
    color: ${newtheme.colors.white};
    width: max-content;
    margin-left: auto;
    margin-right: auto;
    margin-top: 100px;

    ${newtheme.cssBreakpoints.tiny} {
        margin-left: auto;
        margin-right: auto;
        font-size: 10px;
        margin-top: 26px;
    }
`;

const Ratings: FC<IPropsFromDispatch> = (props) => (
    <RatingsWrapper>
        <Container>
            <Wrapper>
                <RatingItem>
                    <RatingHeading>
                        <RatingNumber>4.7</RatingNumber>
                        <RatingPlatform>
                            app
                            <br />
                            store
                        </RatingPlatform>
                    </RatingHeading>
                    <RatingStars>
                        <RatingStarsImage />
                    </RatingStars>
                    <RatingPlatformButton onClick={() => props.openModal(ModalTypes.DownloadTheApp)}>
                        <AppStoreButtonIcon />
                    </RatingPlatformButton>
                </RatingItem>
                <RatingItem>
                    <RatingHeading>
                        <RatingNumber>4.7</RatingNumber>
                        <RatingPlatform>
                            play
                            <br />
                            store
                        </RatingPlatform>
                    </RatingHeading>
                    <RatingStars>
                        <RatingStarsImage />
                    </RatingStars>
                    <RatingPlatformButton onClick={() => props.openModal(ModalTypes.DownloadTheApp)}>
                        <PlayStoreButtonIcon />
                    </RatingPlatformButton>
                </RatingItem>
                <RatingItemMobile>
                    <RatingPlatformButton target="_blank" href={isIOS ? config.iosAppLink : config.androidAppLink}>
                        {isIOS ? <AppStoreButtonIcon /> : <PlayStoreButtonIcon />}
                    </RatingPlatformButton>
                    <RatingStars>
                        <RatingStarsImage />
                    </RatingStars>
                </RatingItemMobile>
            </Wrapper>
            <RatingsDate>Global ratings as of July 27th 2022</RatingsDate>
        </Container>
    </RatingsWrapper>
);
function mapStateToProps() {
    return {};
}

function mapDispatchToProps(dispatch: Dispatch): IPropsFromDispatch {
    return bindActionCreators({ openModal }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Ratings);
